import React from 'react';
import { Lock, Send, Code } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const FeaturesSection = () => {
  const features = [
    {
      icon: Lock,
      title: 'Strong jurisdiction-based privacy protection',
      description: 'Encryptofy Mail operates under Swiss jurisdiction, ensuring your data is protected by some of the world’s strictest privacy laws and regulations.',
      bgColor: 'bg-blue-100',
      iconColor: 'text-blue-800',
    },
    {
      icon: Send,
      title: 'Easy migration and account transfer',
      description: 'With our Express Transfer system, you can seamlessly move from any email provider to Encryptofy Mail. Import emails, labels, contacts, and calendar data with automatic forwarding for incoming messages.',
      bgColor: 'bg-teal-100',
      iconColor: 'text-teal-600',
    },
    {
      icon: Code,
      title: 'Fully transparent security framework',
      description: 'Built on open-source foundations and regularly audited by independent security experts, our platform ensures full transparency and accountability in protecting your communications.',
      bgColor: 'bg-blue-100',
      iconColor: 'text-blue-800',
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <Card 
              key={index} 
              className="border-0 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 bg-white overflow-hidden group"
            >
              <CardContent className="p-8 space-y-6">
                <div className={`w-16 h-16 ${feature.bgColor} rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
                  <feature.icon className={`h-8 w-8 ${feature.iconColor}`} strokeWidth={2} />
                </div>
                
                <h3 className="text-2xl font-bold text-gray-900 leading-tight">
                  {feature.title}
                </h3>
                
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>

                {/* Decorative bottom accent */}
                <div className="pt-4">
                  <div className={`h-1 w-0 group-hover:w-full ${feature.iconColor === 'text-blue-800' ? 'bg-blue-800' : 'bg-teal-500'} transition-all duration-500`}></div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;